import { IOperationResult, IPaged, IProject, IQueryParams } from '@ipnote/interface';
import { createActionGroup, props } from '@ngrx/store';

export const projectsActions = createActionGroup({
  source: 'Projects',
  events: {
    'load projects': props<{ pagedQueryParams: IQueryParams }>(),
    'load projects success': props<{ projects: IPaged<IProject> }>(),
    'load projects failure': props<{ error: string }>(),

    'delete projects': props<{ projectsIds: number[] }>(),
    'delete projects success': props<{ projectsIds: number[], result: IOperationResult }>(),
    'delete projects failure': props<{ error: string }>(),
  },
});